export default __webpack_public_path__ + "static/poster-cb10eacbf2f8d4f024a9194de4eae1e4.png";